import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FaRegCopy } from 'react-icons/fa';
import { message } from 'antd';

import { Alert, LoadingAnimation, Modal, ModalBody, ModalHeader } from '../../../public/components/View';
import FormattedDate from '../../../common/components/FormattedDate';
import { ElapsedTime } from '../../../common/components/ElapsedDateTime';
import { Button } from '../../../public/components/Action';
import { RestBuilder } from '../../../public/utils/rest';
import schema from '../../../common/schema';

import { saveUserInfoAction } from '../../../common/action-creators/auth';
import { paramsForGET, paramsForGet, referralLink, urlForUserInfo } from '../../../common/rest';
import { tokenSelector, userSelector } from '../../../common/selectors/auth';
import KeyValueList from '../../Announcements/components/KeyValueList';

import styles from './styles.scss';

const propTypes = {
    token: PropTypes.string,
    user: PropTypes.shape({
        username: PropTypes.string,
        phone: PropTypes.string,
        subscription: PropTypes.string,
        referralCode: PropTypes.string,
        expiryDate: PropTypes.number,
    }),
    saveUserInfo: PropTypes.func.isRequired,
    onClose: PropTypes.func,
};

const defaultProps = {
    token: '',
    user: {},
    onClose: undefined,
};

const mapStateToProps = state => ({
    token: tokenSelector(state),
    user: userSelector(state),
});

const mapDispatchToProps = dispatch => ({
    saveUserInfo: params => dispatch(saveUserInfoAction(params)),
});

@connect(mapStateToProps, mapDispatchToProps)
@CSSModules(styles, { allowMultiple: true })
export default class UserInfo extends React.PureComponent {
    static defaultProps = defaultProps;
    static propTypes = propTypes;

    constructor(props) {
        super(props);

        this.state = {
            token: props.token,
            pending: true,
            referralCode: '-',
            showCopiedMessage: false,
        };

        this.userInfoRequest = this.createRequestForUserInfo();
    }

    componentWillMount() {
        this.userInfoRequest.start();
    }

    componentWillUnmount() {
        this.userInfoRequest.stop();
    }

    getKeyValueUserInfo = (userInfo = {}) => {
        const { username, phone, expiryDate, referralCode } = userInfo;

        const keyValue = [
            {
                key: 'Username',
                value: username,
            },
            {
                key: 'Phone Number',
                value: phone,
            },

            // {
            //     key: 'Referral Code ',
            //     value: <div className={styles.referralLink}>
            //         <p style={{ margin: '0', padding: '0' }}>{referralCode}</p>
            //         {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            //         <span className={styles.clipIcons}>
            //             <FaRegCopy
            //                 onClick={() => {
            //                     navigator.clipboard.writeText(
            //                         `${location.origin}
            //                         /register?referral=${this.state.referralCode}`)
            //                         .then(
            //                             (result) => {
            //                                 message.success('Referral Code Copied ');
            //                             }).catch((ex) => {
            //                                 console.log(ex);
            //                             });
            //                 }}
            //                 style={{ fontSize: '15px' }}
            //             />
            //         </span>
            //     </div>,
            // },
            {
                key: 'Expiry Date',
                value:
                    (
                        <div>
                            <FormattedDate date={expiryDate} />
                            <ElapsedTime end={expiryDate} prefix=" ( " suffix=" )" invalidText="" />
                        </div>
                    ),
            }];
        return keyValue;
    }

    getUserReferralCode = userId => fetch(`${referralLink}/referral/getUserInfo?userId=${userId}`)
        .then(result => result.json())
        .then((result) => {
            this.setState({ referralCode: result.referralCode });
            return result.referralCode;
        }).catch(ex => '-')

    createRequestForUserInfo = () => {
        const { token } = this.state;
        const requestForUserInfo = new RestBuilder()
            .url(urlForUserInfo)
            .decay(0.3)
            .maxRetryTime(3000)
            .maxRetryAttempts(10)
            .params(paramsForGet({ token }))
            .preLoad(() => {
                this.setState({ pending: true });
            })
            .postLoad(() => {
                this.setState({ pending: false });
            })
            .success(async (response) => {
                try {
                    schema.validate(response, 'userInfoResponse');
                    response.referralCode = await this.getUserReferralCode(response.username);

                    this.props.saveUserInfo({
                        userInfo: response,
                    });
                } catch (er) {
                    console.error(er);
                }
            })
            .failure((response) => {
                console.info('FAILURE:', response);
            })
            .fatal((response) => {
                console.info('FATAL:', response);
            })
            .build();
        return requestForUserInfo;
    }

    render() {
        const {
            user,
            onClose,
        } = this.props;

        const { pending } = this.state;

        return (
            <Modal
                closeOnEscape
                onClose={onClose}
                closeOnBlur
                styleName="user-info"
            >
                <ModalHeader
                    title="User Info"
                    rightComponent={
                        <Button
                            onClick={onClose}
                            transparent
                        >
                            <span className="ion-android-close" />
                        </Button>
                    }
                />
                <ModalBody>
                    {pending && <LoadingAnimation />}
                    <KeyValueList list={this.getKeyValueUserInfo(user.userInfo)} />
                </ModalBody>

                <Alert
                    show={this.state.showCopiedMessage}
                    onClose={() => {
                        this.setState({ showCopiedMessage: false });
                    }}
                    title={'success'}
                >
                    <p>Referral Token Copied</p>
                </Alert>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/topic/UserInfo/views/index.js